module.exports = __webpack_public_path__ + "static/media/main idea.f9685f73.mp3";